var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFamilyMe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Family_Me_svg__a,.Family_Me_svg__b{fill:none}.Family_Me_svg__b{stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Family_Me_svg__a",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Family_Me_svg__b",
    d: "M8.505 7.572a2.252 2.252 0 11-3.185 0 2.252 2.252 0 013.185 0M18.681 7.572a2.252 2.252 0 11-3.185 0 2.252 2.252 0 013.185 0M9.42 17.09H2.884a.565.565 0 01-.564-.563v-.565a2.461 2.461 0 011.58-2.055 7.877 7.877 0 013.506-.771 6.327 6.327 0 014.6 1.591 3.612 3.612 0 00-1.811.709 1.884 1.884 0 00-.775 1.491v.162zM21.363 17.09h-6.531a2.7 2.7 0 00-2.59-2.361 6.306 6.306 0 014.6-1.593 7.891 7.891 0 013.505.769 2.46 2.46 0 011.58 2.053v.564a.567.567 0 01-.564.568z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "Family_Me_svg__a",
    d: "M0 0h24v24H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "Family_Me_svg__b",
    d: "M12.965 10.705a1.216 1.216 0 11-1.719 0 1.216 1.216 0 011.719 0"
  })));
}
export default SvgFamilyMe;


//////////////////
// WEBPACK FOOTER
// ./src/components/Quoters/Aflac/icons/Family_Me.svg
// module id = 1047
// module chunks = 11